/* ============================================================
   SPICY DADDA, Open Channel: tractor-beam submit sequence
   On submit: hold the form while a UFO flies in, beams a cone
   over the fields, vacuums them up, then flies away — THEN the
   real Shopify contact form submission fires (full page POST,
   handled server-side via {% form 'contact' %} / form.posted_successfully?).
   ============================================================ */
(() => {
  'use strict';

  const prefersReducedMotion =
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const channelForm = document.querySelector('.channel-form');
  if (!channelForm) return;
  if (prefersReducedMotion) return; // submit natively, no animation

  channelForm.addEventListener('submit', (e) => {
    if (channelForm.dataset.submitting) return; // animation already in flight, let it through
    if (!channelForm.checkValidity()) return;    // let native required/email validation block first

    e.preventDefault();
    channelForm.dataset.submitting = 'true';

    const ufo = document.createElement('img');
    ufo.src = window.themeAssets ? window.themeAssets.ufoFull : '';
    ufo.className = 'tractor-ufo';
    ufo.alt = '';
    ufo.setAttribute('aria-hidden', 'true');
    const beam = document.createElement('div');
    beam.className = 'tractor-beam';
    beam.setAttribute('aria-hidden', 'true');
    channelForm.appendChild(beam);
    channelForm.appendChild(ufo);

    // 1. UFO descends into view from the top
    ufo.animate([
      { transform: 'translateX(-50%) translateY(-170px)', opacity: 0 },
      { transform: 'translateX(-50%) translateY(0)', opacity: 1 }
    ], { duration: 700, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' });

    // 2. beam fires + fields get vacuumed up
    setTimeout(() => channelForm.classList.add('is-abducting'), 650);

    // 3. UFO (job done) banks away off-screen
    setTimeout(() => {
      ufo.animate([
        { transform: 'translateX(-50%) translateY(0)', opacity: 1 },
        { transform: 'translateX(130vw) translateY(-90px) rotate(12deg)', opacity: 0 }
      ], { duration: 750, easing: 'cubic-bezier(0.5, 0, 0.9, 0.4)', fill: 'forwards' });
    }, 2300);

    // 4. after 3s total, let the real submission go through
    setTimeout(() => {
      channelForm.submit();
    }, 3000);
  });
})();
